controllers.controller('AddNewAccountController', [
    '$scope', '$state', '$ionicLoading', 'LocaleService', 'Storage', 'API', 'Validator', 'ErrorService', 'constants',
    'config', 'UserControl', 'UserService', 'Utils', 'CountryService',
    function ($scope, $state, $ionicLoading, LocaleService, Storage, API, Validator, ErrorService, Const,
              Config, UserControl, UserService, Utils, CountryService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        var user = UserService.get();
        $scope.liveAccont = true;
        $scope.currencies = [];

        var userCountry = CountryService.countries.get({code: user.country});
        var allowedCurrencies = userCountry && userCountry.allowedCurrencies
            && userCountry.allowedCurrencies.length && userCountry.allowedCurrencies;

        if (allowedCurrencies && allowedCurrencies.length) {
            $scope.currencies = (Storage.get('currencies') || []).filter(function (currency) {
                return allowedCurrencies.indexOf(currency.currency) !== -1;
            });
        }
        if (!$scope.currencies.length) {
            $scope.currencies = (Storage.get('currencies') || []).filter(function (currency) {
                return currency.currency === userCountry.currency;
            });
        }


        $scope.validator = Validator.getPattern;
        $scope.useDemoAccounts = Storage.get('useDemo');
        $scope.showLeverage = Const.showLeverageDropdown;
        $scope.constants = Const;

        var accountRule = Const['scoringRules'] && _.find(Const['scoringRules'], {classification: user.classification});
        $scope.leverages = accountRule ? accountRule.leverages : Config.leverages;
        $scope.demoDepositValues = Storage.get('demoDepositValues');

        $scope.addAccount = {
            currency: _.find($scope.currencies, function (currency) {
                return currency.currency === user.baseCurrency
            }) || $scope.currencies[0],
            leverage: _.find($scope.leverages, function (leverage) {
                return leverage === Config.defaultLeverage;
            }) || $scope.leverages[0]
        };
        $scope.addAccountDefaults = {
            min: 100,
            max: 50000,
            value: Const.initialDeposit
        };

        $scope.platforms = Storage.get("tradingPlatforms").map(function (platform) {
            return {
                id: platform,
                label: $scope.translation[platform] || platform
            }
        });

        if (Const['platformSelect']) {
            $scope.addAccount.platform = _.find($scope.platforms, {id: Storage.get("defaultTradingPlatform")});
        }

        var maxLiveAccounts = Storage.get('maxLiveAccounts');

        $scope.customerTypes = Storage.get('customerTypes') || [];

        var defaultCustomerType = _.find($scope.customerTypes, {selected: 1});
        if (defaultCustomerType) {
            $scope.addAccount.customerType = defaultCustomerType;
        }

        var modalDefaults = {
            isError: false,
            textTitle: '',
            textContent: '',
            state: false,
            isProcess: false
        };

        $scope.modal = angular.copy(modalDefaults);


        $scope.setForm = function (data) {
            $scope.form = data;
        };

        $scope.toggleAccount = function (live) {
            $scope.liveAccont = live;
        };

        $scope.$on('$ionicView.beforeEnter', function () {
            var state = UserControl.getState();
            state && $state.go(state, {cache: false});
            resetDepositDefaults();
        });

        function checkResponse(response, request) {
            if (response.status === 0) {
                throw new ErrorService({
                    source: 'AddNewAccountController',
                    type: Const.error.type.VALIDATION,
                    severity: 'warning',
                    code: response.code || 'general_error',
                    data: {
                        request: request,
                        response: response
                    }
                })
            }
            return response;
        }

        $scope.sendAccount = function (form) {
            Utils.formRevalidate(form, true);
            if (!form.$valid) return;

            var createAccountRequest = {
                live: $scope.liveAccont ? 1 : 0,
                currency: $scope.addAccount.currency.currency,
                leverage: $scope.addAccount.leverage + '',
                initialDeposit: $scope.liveAccont ? 0 : $scope.addAccountDefaults.value
            };

            if (Const['platformSelect']) {
                createAccountRequest.tradingPlatform = $scope.addAccount.platform.id;
            }

            if (Const['customerTypeForTA']) {
                createAccountRequest.customerType = $scope.addAccount.customerType.name || '';
            }

            $ionicLoading.show();

            API.mt4CreateAccount(createAccountRequest)
                .then(function (response) {
                    return checkResponse(response, createAccountRequest);
                })
                .then(function (response) {
                    $ionicLoading.hide();
                    user.addTradingAccount(response.mt4Account);
                    $scope.modal.isError = false;
                    $scope.modal.isProcess = false;
                    $scope.modal.textTitle = LocaleService.translation.messages.createAccountSuccess;
                    $scope.modal.back = "root.app.manageAccounts";
                    $scope.modal.actionText = LocaleService.translation.back;
                    $scope.modal.state = true;
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.isError = true;
                    $scope.modal.isProcess = false;
                    $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code] && LocaleService.translation.messages[error.code].replace(/\%X\%/, maxLiveAccounts)) || LocaleService.translation.messages.general_error;
                    $scope.modal.textContent = LocaleService.translation.messages.createAccountFailed;
                    $scope.modal.actionText = LocaleService.translation.try_again;
                    $scope.modal.state = true;
                });
        };

        function resetDepositDefaults() {
            var demoDepositValue = $scope.demoDepositValues.find(function (demoDepositValue) {
                return demoDepositValue.currency === $scope.addAccount.currency.currency
            });

            if (!!demoDepositValue) {
                $scope.addAccountDefaults = {
                    min: demoDepositValue.minimum,
                    max: demoDepositValue.maximum,
                    value: demoDepositValue.visual
                };
            }
        }

        var addAccountCurrencyWatch = $scope.$watch('addAccount.currency', function (newVal, oldVal) {
            if (newVal !== oldVal && newVal) {
                resetDepositDefaults();
            }
        });

        $scope.$on('$ionicView.beforeLeave', addAccountCurrencyWatch);
        $scope.$on('$ionicView.unloaded', addAccountCurrencyWatch);
        $scope.$on('clear', addAccountCurrencyWatch);
    }]);
